import React from 'react'
import _ from 'lodash'

export class TravelChoice extends React.Component {
    constructor(props) {
        super(props)  
    }

    render() {
        return (
            <div>
                <div className="row section-title">
                    <div className="col-sm-12">
                        <h1>Getting There.</h1>
                    </div>
                </div>
                <div className="row stacked-blocks">
                    <div className="col-sm-6 col-sm-offset-3">
                        <a 
              className="btn btn-large"
              onClick={() => this.props.updateDetailSections(this.props.leg, this.props.availableDetailSections.TRAVEL, this.props.availableDetailSubSections.SEARCH) }>
              Give me recommendations
                        </a>
                        <a 
              className="btn btn-large"
              onClick={() => this.props.updateDetailSections(this.props.leg, this.props.availableDetailSections.TRAVEL, this.props.availableDetailSubSections.LUNA) }>
              Let Luna take care of it</a>
                        <a 
              className="btn btn-plain"
              onClick={() => this.props.updateDetailSections(this.props.leg, this.props.availableDetailSections.TRAVEL, this.props.availableDetailSubSections.ENTRY) }>
              I Have a reservation
                        </a>
            
                    </div>
                </div>
            </div>
        )
    }
}